/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Template_MinimalInputs */

const cs_public_site_template_minimal = /** @type {(inputs: Public_Site_Template_MinimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalistický`)
};

const en_public_site_template_minimal = /** @type {(inputs: Public_Site_Template_MinimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimal`)
};

/**
* | output |
* | --- |
* | "Minimal" |
*
* @param {Public_Site_Template_MinimalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_template_minimal = /** @type {((inputs?: Public_Site_Template_MinimalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Template_MinimalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_template_minimal(inputs)
	return cs_public_site_template_minimal(inputs)
});